var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMici = function SvgMici(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M12 14.1a2.54 2.54 0 0 0 2.56-2.52l.01-5.05a2.57 2.57 0 0 0-5.14 0v5.05A2.55 2.55 0 0 0 12 14.1m4.54-2.52a4.41 4.41 0 0 1-4.54 4.3 4.41 4.41 0 0 1-4.54-4.3H6a5.91 5.91 0 0 0 5.14 5.66V20h1.72v-2.76A5.91 5.91 0 0 0 18 11.58z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMici);
export default ForwardRef;